export default __webpack_public_path__ + "static/media/cat.359cba81.svg";